require('waypoints/lib/noframework.waypoints');
require('waypoints/lib/shortcuts/sticky');
require('./modules/jquery.toTop');
require('./modules/jquery.prettyPhoto');
var Flickity = require('flickity-imagesloaded');
// var Instafeed = require('instafeed.js');
var googleMaps = require('./modules/jquery.googleMaps');

/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
* ======================================================================== */

;(function(factory) {
	'use strict';
  
  // Global
  factory(jQuery);
})(function($) {
    'use strict';

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var TURGEON = {
        // All pages
        'common': {
            init: function() {

                // JavaScript to be fired on all pages

                // Mobile nav
                $('a[href="#nav-mobile"]').click(function(e) {
                    e.preventDefault();
                    // toggle nav
                    $('#nav-mobile').toggleClass('nav-mobile--active');
                });

                // Search form
                $('a[href="#product-search"]').click(function(e) {
                    e.preventDefault();
                    // toggle search form
                    var headerSearch = $('.header__search');
                    // focus input
                    if (headerSearch.hasClass('header__search--active')) {
                        headerSearch.removeClass('header__search--active').find('[type="search"]').first().blur();
                    } else {
                        headerSearch.addClass('header__search--active').find('[type="search"]').first().focus();
                    }
                    // toggle active class
                    $('a[href="#product-search"]').toggleClass('active');
                });

                // Modals
                $('[data-modal-toggle]').on('click', function(e) {
                  e.preventDefault();
                  var $modal = $($(this).data('modal-toggle'));
                  $modal.toggleClass('modal--is-active');
                });

                // ESC key actions
                $(document).keyup(function(e) {
                    if (e.keyCode === 27) { // escape key maps to keycode `27`
                        // close search form
                        var headerSearch = $('.header__search');
                        headerSearch.removeClass('header__search--active').find('[type="search"]').first().blur();
                        // remove active class from nav selector(s)
                        $('a[href="#product-search"]').removeClass('active');
                        // close mobile nav
                        $('#nav-mobile').removeClass('nav-mobile--active');
                        // close any open modals
                        $('.modal').removeClass('modal--is-active');
                    }
                });

                // Print page links
                $('.print').on('click', function(e) {
                    e.preventDefault();
                    window.print();
                });

                // to top link
                $('.footer__to-top').toTop({
                    min: 400,
                    fadeSpeed: 500
                });

                // smooth scrolling
                $('.smooth-scroll').click(function() {
                  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                    if (target.length) {
                      $('html, body').animate({
                        scrollTop: target.offset().top
                      }, 1000);
                      return false;
                    }
                  }
                });

                // google maps
                $('.google-map').each(function() {
                    googleMaps.create($(this));
                });

            }
        },
        'home': { // Home
            init: function() {

                /* Instafeed
                var instafeedId = 'instagram';
                if (theme_mods.instagram.enabled === true) {
                  var feed = new Instafeed({
                      get: 'user',
                      userId: theme_mods.instagram.user_id,
                      accessToken: theme_mods.instagram.access_token,
                      filter: function(model) {
                        model.captionNoHashTags = model.caption.text.replace(/\#\w\w+\s?/g, '');
                        return true;
                      },
                      target: instafeedId,
                      limit: 4,
                      resolution: 'standard_resolution',
                      template: '\
                      <div class="instagram__item"> \
                        <figure>\
                          <img src="{{image}}">\
                          </figure>\
                          <a href="{{link}}" target="_blank" class="content">\
                            <p>{{model.captionNoHashTags}}</p>\
                          </a>\
                      </div> <!-- end .instagram__item -->'
                  });
                  feed.run();
                } else {
                  $('#' + instafeedId).remove();
                }
                */

            },
            load: function() {

                // add custom methods
                Flickity.createMethods.push('_createPrevNextCells');

                // init prev / next cells
                Flickity.prototype._createPrevNextCells = function() {
                    this.on( 'cellSelect', this.setPrevNextCells );
                };

                // custom methods
                Flickity.prototype.setPrevNextCells = function() {
                    // remove classes
                    if (this.previousCell) {
                        this.previousCell.element.classList.remove('is-previous');
                    }
                    if (this.nextCell) {
                        this.nextCell.element.classList.remove('is-next');
                    }
                    // set cells
                    this.previousCell = this.cells[this.selectedIndex - 1];
                    this.nextCell = this.cells[this.selectedIndex + 1];
                    // add classes
                    if (this.previousCell) {
                        this.previousCell.element.classList.add('is-previous');
                    }
                    if (this.nextCell) {
                        this.nextCell.element.classList.add('is-next');
                    }
                };

                // initialize hero slideshow
                new Flickity('.hero-slideshow', {
                    draggable: false,
                    prevNextButtons: false,
                    autoPlay: 4000, // 4 seconds
                    pauseAutoPlayOnHover: true,
                    wrapAround: true,
                    // imagesLoaded: true,
                    // lazyLoad: 1 // load image in next cell
                });

                // initialize featured products slideshow
                new Flickity('.featured-products .products', {
                    // contain: true,
                    draggable: false,
                    prevNextButtons: true,
                    pageDots: false,
                    wrapAround: true,
                    arrowShape: 'M68.13,100a.81.81,0,0,1-.48-.16L.34,50.66a.82.82,0,0,1,0-1.32L67.65.16a.82.82,0,1,1,1,1.32L2.2,50,68.61,98.52a.82.82,0,0,1-.48,1.48Zm.65-8.33a.82.82,0,0,0-.18-1.14L13.14,50,68.68,9.42a.82.82,0,1,0-1-1.32L11.28,49.34a.82.82,0,0,0,0,1.32L67.64,91.85a.82.82,0,0,0,1.14-.18Zm0-8a.82.82,0,0,0-.18-1.14L24.08,50,68.66,17.43a.82.82,0,1,0-1-1.32L22.21,49.34a.82.82,0,0,0,0,1.32L67.62,83.84a.82.82,0,0,0,1.14-.18Zm-.1-8.07a.82.82,0,0,0-.18-1.14L35,50,68.57,25.49a.82.82,0,1,0-1-1.32L33.15,49.34a.82.82,0,0,0,0,1.32L67.52,75.77a.82.82,0,0,0,1.14-.18Zm0-8a.82.82,0,0,0-.18-1.14L46,50,68.62,33.45a.82.82,0,1,0-1-1.32L44.09,49.34a.82.82,0,0,0,0,1.32L67.51,67.77a.82.82,0,0,0,1.14-.18Zm0-8a.82.82,0,0,0-.18-1.14L56.9,50l11.85-8.66a.82.82,0,1,0-1-1.32L55,49.34a.82.82,0,0,0,0,1.32L67.5,59.77a.82.82,0,0,0,1.14-.18Z',
                    // percentPosition: true,
                    // imagesLoaded: true,
                    // lazyLoad: 1 // load image in next cell
                });

            }
        },
        'tax_product_cat': { // Product Category
            init: function() {

                /*
                // show filters on hover
                $('.filters').hover(function() {
                    $(this).addClass('filters--hover');
                }, function() {
                    $(this).removeClass('filters--hover');
                });
                */

                $('.filters__header-wrapper h3').on('click', function(e) {
                    e.preventDefault();
                    $('.filters').toggleClass('filters--on');
                });

                // sticky filters that scroll with the page
                var sticky = new Waypoint.Sticky({
                    element: $('.filters')[0],
                    stuckClass: 'filters--stuck',
                    wrapper: '<div class="filters-wrapper" />'
                });

                // hide filters with no items


            }
        },
        'single_product': { // Single product
            init: function() {

                $("a[rel^='prettyPhoto']").prettyPhoto({
                  social_tools: null,
                  theme: 'dark_rounded'
                });

                $('[data-image-swap]').on('click', function(e) {
                  e.preventDefault();
                }).on('mouseover', function(e) {
                    var $self = $(this);
                    var $target = $($self.data('image-swap'));
                    if ($target.length) {
                        // update link & attributes
                        $target.addClass('active')
                            .attr('href', $self.attr('href'))
                            .attr('title', $self.attr('title'));
                        // update image
                        var $image = $target.find('img');
                        $image.attr('src', $self.attr('href'))
                            .removeAttr('srcset')
                            .removeAttr('sizes');
                    }
                });

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = TURGEON;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        readyEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        },

        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('load');

            // Fire page-specific init JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm, 'load');
            });
        }

    };

    // Executes a bit earlier than window.onload and called once the DOM(Document object model) is loaded on your page
    $(document).ready(UTIL.readyEvents);

    // The load event fires when all the content on your page fully loaded including the DOM
    $(window).on('load',UTIL.loadEvents);

})